import axios from 'axios'
import APIConfig from '@/data/remote/APIConfig.js'

export default class NotificationService {
    constructor() {
        this.unreadTS = null
        this.readedTS = null
        this.currentReadedPage = 0
        this.firstUnreadTS = null
        this.apis = {
            getAll: () => axios.get(APIConfig.APIURL + '/notification'),
            add: (payload) => axios.post(APIConfig.APIURL + '/notification', payload),
            edit: (id, payload) => axios.put(APIConfig.APIURL + `/notification/${id}`, payload),
            inActivate: (id) => axios.post(APIConfig.APIURL + `/notification/${id}/inactivate`),
            // delete: (id) => axios.delete(APIConfig.APIURL + `/notification/${id}`),
            getUnread: (ts) => axios.get(APIConfig.APIURL + '/notification/unread', { params: { ts } }),
            getReaded: (ts, page) => axios.get(APIConfig.APIURL + '/notification/readed', { params: { ts, page } }),
            click: (id) => axios.post(APIConfig.APIURL + `/notification/click/${id}`),
            read: (ids) => axios.post(APIConfig.APIURL + '/notification/read', { 'IDArray': ids }),
        }
    }

    prepareData(vm) {
        return new Promise((resolve, reject) => {
            if (vm.$store.state.notification.unread.isFetched) {
                resolve(vm.$store.state.notification.unread.list)
                return
            }
            if (vm.$store.state.notification.unread.isFetching) {
                var timer = setInterval(() => {
                    if (vm.$store.state.notification.unread.isFetching) return
                    clearInterval(timer)
                    if (vm.$store.state.notification.unread.isFetched) {
                        resolve(vm.$store.state.notification.unread.list)
                    } else {
                        reject('無法取得資料，請嘗試重新整理')
                    }
                }, 500)
                return
            }
            return this.getUnread(vm)
                .then(res => {
                    vm.$store.state.notification.unread.isFetched = true
                    vm.$store.state.notification.unread.list = res.data.result.notifications
                    return res
                })
                .then(res => {
                    vm.$store.state.notification.unread.isFetching = false
                    resolve()
                    return res
                })
                .catch(err => {
                    vm.$store.state.notification.unread.isFetching = false
                    reject(err)
                })
        })
    }

    getAll(vm) {
        return new Promise((resolve, reject) => {
            this.apis.getAll()
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    add(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.add(payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    edit(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.edit(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    inActivate(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.inActivate(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    delete(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.delete(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    getUnread(vm) {
        return new Promise((resolve, reject) => {
            this.apis.getUnread(this.unreadTS)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        if (!this.firstUnreadTS) this.firstUnreadTS = res.data.result.ts
                        this.unreadTS = res.data.result.ts
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    if (err.isAxiosError && err.message == "Network Error") return window.console.warn(`getunread, network error`)
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    getReaded(vm) {
        return new Promise((resolve, reject) => {
            if (!this.readedTS) this.readedTS = this.firstUnreadTS
            this.apis.getReaded(this.readedTS, this.currentReadedPage + 1)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        this.readedTS = res.data.result.ts
                        if (this.currentReadedPage == 0)
                            vm.$store.state.notification.readed.totalCount = res.data.result.count
                        this.currentReadedPage += 1
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    recordClicked(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.click(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        var idx = vm.$store.state.notification.unread.list.findIndex(o => o.ID == id)
                        if (idx >= 0) {
                            vm.$set(vm.$store.state.notification.unread.list[idx], 'ClickedAt', new Date());
                        }

                        idx = vm.$store.state.notification.readed.list.findIndex(o => o.ID == id)
                        if (idx >= 0) {
                            vm.$set(vm.$store.state.notification.readed.list[idx], 'ClickedAt', new Date());
                        }
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    read(vm, ids) {
        return new Promise((resolve, reject) => {
            this.apis.read(ids)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {

                        for (var i = 0; i < vm.$store.state.notification.unread.list.length; ++i) {
                            if (ids.includes(vm.$store.state.notification.unread.list[i].ID)) {
                                vm.$set(vm.$store.state.notification.unread.list[i], 'ViewedAt', new Date());
                            }
                        }
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }
}
